import React, {Component} from 'react';
import FilterByPoints from 'components/organisms/filter-by-points';
import ExposureMode from 'components/molecules/exposure-mode';
import UserPointsType from 'components/molecules/user-points-type';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import PlayerNameStack from 'components/organisms/player-name-stacking';
import OptimizeButton from 'components/molecules/optimize-button';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import RangeOfOutcomes from 'components/organisms/range-of-outcomes/range-of-outcomes';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import OptimizeOpener from 'components/molecules/optimize-opener';
import ProjectedOwnershipCap from 'components/organisms/projected-ownership-cap';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';
import ProjectionBoostRule from 'components/organisms/projection-boost-rule';

class PlayersDashboard extends Component {
    render() {
        return (
            <div>
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterByPoints useDragging={true} />
                            <ProjectedOwnershipCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <UserPointsType
                                options={{
                                    sharpPoints: 'Props Projection',
                                    ceilingPoints: 'Ceiling Projection',
                                    adminPoints: 'Projection',
                                }}
                            />
                            <UniquePlayersQuantity />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomes useDragging={true} config={{sport: 'nfl'}} />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                    </div>
                    <OptimizeButton />
                </div>
                <PlayerNameStack />
                <PlayerGroupingsSwitch>
                    <PlayerCombinationStacking />
                    <ProjectionBoostRule />
                </PlayerGroupingsSwitch>
            </div>
        );
    }
}

export {PlayersDashboard};
